import styled from 'styled-components';

const Seperator = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${({theme}) => theme.color.shaded};
`;

export default Seperator;

